import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { fg } from '@atlaskit/platform-feature-flags';
// Retrieve the initial config value from the editor view plugin preset
var getViewModeSync = function getViewModeSync(preset) {
  var _editorViewModePlugin;
  if (!fg('platform_editor_sync_editor_view_mode_state')) {
    return undefined;
  }
  // @ts-expect-error - data is a private property
  var editorViewModePlugin = preset.data.find(function (p) {
    if (Array.isArray(p)) {
      var _p = _slicedToArray(p, 2),
        plugin = _p[0],
        config = _p[1];
      return plugin({
        config: config
      }).name === 'editorViewMode';
    } else {
      var _p2;
      return (p === null || p === void 0 || (_p2 = p({
        config: undefined
      })) === null || _p2 === void 0 ? void 0 : _p2.name) === 'editorViewMode';
    }
  });
  // If we have set a default value on the view mode (index 1) then we can return the mode, otherwise we haven't set by default
  return Array.isArray(editorViewModePlugin) ? (_editorViewModePlugin = editorViewModePlugin[1]) === null || _editorViewModePlugin === void 0 ? void 0 : _editorViewModePlugin.mode : undefined;
};

// Temporary to ensure view mode is always set synchronously
// TODO: ED-27194 - Make editorAPI be set synchronously and we can remove this code
export var getEditorViewMode = function getEditorViewMode(editorViewModeState, preset) {
  if (!(editorViewModeState !== null && editorViewModeState !== void 0 && editorViewModeState.mode)) {
    return getViewModeSync(preset);
  }
  return editorViewModeState === null || editorViewModeState === void 0 ? void 0 : editorViewModeState.mode;
};